export default [
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"I am good. Maybe later."`,
        speakerTxtRS: `"Ne, hvala. Možda kasnije."`,
        dialogFx: `assets/dialog/joseph/joseph0033.mp3`,
        choicesBtns: `unset`
    }
]